module.exports = __webpack_public_path__ + "img/benefits-18.b07b6eec.svg";